interface WebsiteThemes {
  themes: {
    mobile: string
    desktop: string
  }
}

type WebsiteSetting = Record<string, WebsiteThemes>

let cachedSetting: WebsiteSetting | undefined

const loadSetting = async (): Promise<WebsiteSetting> => {
  if (cachedSetting !== undefined) {
    return cachedSetting
  }

  try {
    const response = await fetch("/source/setting.json")
    if (!response.ok) {
      throw new Error(`Failed to load setting: ${response.statusText}`)
    }
    const setting = (await response.json()) as WebsiteSetting
    cachedSetting = setting
    return setting
  } catch (error) {
    console.error("Error loading setting:", error)
    return {}
  }
}

export default loadSetting
